<template>
  <el-cascader
    v-if="propertyId"
    ref="cascader"
    :show-all-levels="false"
    :props="cascaderProps"
    width="160px"
    @change="handleValueChanged"
    v-model="cascaderValue"
    clearable
  >
    <template slot-scope="{ node, data }">
      <template v-if="data.valuePic">
        <span
          v-if=" data.valuePic.picType === 'rgb'"
          class="property-bg"
          :style="{'background': data.valuePic.picValue}"
        >
        </span>
        <span v-else class="property-bg">
          <img :src="data.valuePic.picValue" />
        </span>
      </template>
      <span>{{ data.propertyValueName }}</span>
    </template>
  </el-cascader>
</template>

<script>
import { cloneDeep, last } from 'lodash';
import { fxgGetCascadeValues } from '@/api/prod/center';
export default {
  data() {
    return {
      options: [],
      propertyId: null,
      cascaderValue: null
    };
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    showValue: {
      type: [Array, String, Number],
      default: '',
    },
    navigations: {
      type: Array,
      default: [],
    },
    getData: {
      type: Function,
    },
    ruleParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    cascaderProps() {
      const then = this;
      return {
        // multiple: false,
        // checkStrictly: false,
        lazy: true,
        // emitPath: false,
        // levelPath: true,
        lazyLoad(node, resolve) {
          const { value, label } = node;
          console.log(node)
          if (node.root === true) {
            console.log('rootSearch', then.propertyId);
            // resolve([])
            then.getData(then.propertyId).then(data => {
              // then.options = cloneDeep(data);
              resolve(data);
            });
            return false;
          }
          
          const { cascadeId = 0 } = node.data || {};
          const cascadeInfo = {
            valueId: value,
            valueName: label,
            cascadeId,
          }
          then.getCascadeValues({
            cascadeInfo: [cascadeInfo],
            propertyId: then.propertyId
          }).then((data) => {
            const { hasSubProperty, propertyValues = [] } = data;
            const newPropertyValues = (propertyValues || []).map(item => {
              item.leaf = hasSubProperty === false;
              return item;
            });
            resolve(newPropertyValues);
          });
          // setTimeout(() => {
          //   const nodes = [];
          //   // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          // }, 1000);
        },
        label: 'propertyValueName',
        value: 'propertyValueId',
      };
    },
  },
  created() {
    this.initCascader();
  },
  methods: {
    initCascader() {
      const { propertyId } = this.navigations[0];
      this.propertyId = propertyId;
      if (this.value && this.showValue.length > 0) {
        // console.log(this.$refs.cascader)
        // this.$refs.cascader.inputValue = this.value;
        this.cascaderValue = this.showValue;
        // this.$refs.cascader.presentText = this.value;
        // console.log('this===>Value', this.value)
        // this.$refs.cascader.$refs.panel.checkedValue = this.valueId;
      }
    },
    async getCascadeValues(otherParams) {
      const ruleParams = cloneDeep(this.ruleParams);
      return new Promise(resolve => {
        fxgGetCascadeValues({
          ...ruleParams,
          ...otherParams,
        })
          .then(res => {
            if (res.result !== 1) {
              resolve([]);
              return false;
            }
            const { properties = [] } = res.data;
            resolve(properties[0]);
          })
          .catch(() => {
            resolve([]);
          });
      });
    },
    handleValueChanged(value) {
      const checkedNodes = this.$refs.cascader.getCheckedNodes();
      // this.cascaderValue = value;
      if (checkedNodes.length > 0 && last(checkedNodes)) {
        const lastItem = last(checkedNodes);
        const cpvPathList = value.map(item => {
          return {
            cpid: this.propertyId,
            cpvid: item
          }
        });
        this.$emit('input', lastItem.value)
        this.$emit('change', {
          label: lastItem.label,
          value: lastItem.value,
          showValue: value,
          cpvPathList,
        });
      } else {
        this.$emit('input', '')
      }
      if (this.$parent.$options.componentName === 'ElFormItem') {
        this.$parent.$emit('el.form.change', value);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.property-bg{
  width: 14px;
  height: 14px;
  display: inline-block;
  vertical-align: text-top;
  margin-right: 4px;
  border: 1px solid #eceaea;
  box-sizing: border-box;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
